/**
 * RestroPulse POS · Sprint 3 named constants
 *
 * Tenant-configurable in production. Kept here as literal defaults for
 * the prototype. Every screen that gates on one of these values reads
 * from this file so a single flip changes behaviour everywhere.
 *
 * blind_close_enabled     — Part 7 · when true, the shift-close flow
 *                           hides expected cash until the cashier
 *                           submits their count. Cash-loss control.
 * kds_enabled             — Part 11 · when false, the KDS entry point
 *                           is hidden entirely and slips remain the
 *                           only kitchen artefact.
 * variance_threshold_rupees — Part 7 · closes with cash variance above
 *                           this figure require a reason_code + note.
 * kds_escalation_ms       — Part 11 · [warn, urgent] elapsed thresholds
 *                           on live tickets, in milliseconds.
 * kds_ready_clear_ms      — Part 11 · a ready ticket clears from the
 *                           board after this many milliseconds.
 */
export const POS_CONFIG = Object.freeze({
  blind_close_enabled:        false,      // tenant-configurable in production
  kds_enabled:                false,      // tenant-configurable in production
  variance_threshold_rupees:  100,        // ₹100
  kds_escalation_ms:          [10 * 60_000, 20 * 60_000],   // [warn, urgent]
  kds_ready_clear_ms:         30_000,     // 30 seconds
  // ── Sprint 4 · Part 5 ─────────────────────────────────────────
  // manager_pin  Real production uses a per-user manager PIN issued
  //              by a directory + rotated. In the prototype a single
  //              literal PIN gates every high-authority action.
  //              Real authorisation in production.
  manager_pin:                "1234",
  // discount_ceiling_pct  Discounts above this percentage of the
  //              eligible base require a manager PIN. Below the
  //              ceiling the cashier applies directly. Tenant
  //              configurable in production.
  discount_ceiling_pct:       20,
});
